import { useAmp } from "next/amp";
import React, { FC } from "react";
import styled from "styled-components";

interface Props {
  alt: string;
  src: string;
}

const Twemoji: FC<Props> = ({ alt, src }) => {
  const isAmp = useAmp();

  if (isAmp) {
    return (
      <amp-img
        alt={alt}
        src={src}
        width="1em"
        height="1em"
        className="twemoji"
      />
    );
  }

  return <ImageTag alt={alt} src={src} className="twemoji" />;
};

const ImageTag = styled.img<{ className?: string }>``;

export default Twemoji;
